import { useEffect, useState } from "react";
import adminApi, { fmtDate } from "../../lib/adminApi";
import { formatErr, fmtUsd } from "../../lib/api";
import { toast } from "sonner";

const ACTION_LABEL = {
  credit: "Начисление", debit: "Списание", block: "Блокировка", unblock: "Разблокировка",
  reset: "Сброс", withdrawal_approved: "Вывод одобрен", withdrawal_rejected: "Вывод отклонён",
  prop_approved: "Prop одобрен", prop_rejected: "Prop отклонён", edit_entry_price: "Правка входа",
};
const ACTION_COLOR = {
  credit: "text-[#0ECB81]", debit: "text-[#F6465D]", block: "text-[#F6465D]", unblock: "text-[#0ECB81]",
  reset: "text-[#E3B341]", withdrawal_approved: "text-[#0ECB81]", withdrawal_rejected: "text-[#F6465D]",
  prop_approved: "text-[#0ECB81]", prop_rejected: "text-[#F6465D]",
};

export default function AdminAudit() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    adminApi.get("/admin/actions", { params: { limit: 150 } })
      .then((r) => setItems(r.data)).catch((e) => toast.error(formatErr(e)));
  }, []);

  return (
    <div data-testid="admin-audit">
      <h2 className="text-lg font-semibold text-white mb-4">Журнал действий</h2>
      <div className="bg-[#111827] border border-[#1F2937] rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-[10px] uppercase tracking-wider text-[#6B7280] border-b border-[#1F2937]">
                <th className="text-left px-4 py-2.5">Время</th>
                <th className="text-left px-4 py-2.5">Действие</th>
                <th className="text-left px-4 py-2.5">Цель</th>
                <th className="text-left px-4 py-2.5">Детали</th>
                <th className="text-left px-4 py-2.5">Админ</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} className="border-b border-[#1F2937]/60" data-testid={`audit-row-${a.id}`}>
                  <td className="px-4 py-2.5 text-[11px] text-[#6B7280] whitespace-nowrap">{fmtDate(a.time)}</td>
                  <td className={`px-4 py-2.5 font-medium ${ACTION_COLOR[a.action] || "text-white"}`}>{ACTION_LABEL[a.action] || a.action}</td>
                  <td className="px-4 py-2.5 text-[#9CA3AF] text-xs">{a.target_name || a.target_email || a.target_user_id || "—"}</td>
                  <td className="px-4 py-2.5 text-xs text-[#9CA3AF]">
                    {typeof a.delta === "number" && a.delta !== 0 && (
                      <span className={a.delta > 0 ? "text-[#0ECB81]" : "text-[#F6465D]"}>{a.delta > 0 ? "+" : ""}${fmtUsd(a.delta)} </span>
                    )}
                    {a.amount != null && <span className="mono">${fmtUsd(a.amount)} {a.network || ""} </span>}
                    {a.prop_firm && <span>{a.prop_firm} </span>}
                    {a.reason && <span className="italic">«{a.reason}»</span>}
                  </td>
                  <td className="px-4 py-2.5 text-[11px] text-[#6B7280]">{a.admin_tg_id}</td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-[#6B7280]">Записей нет</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
